package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_profile_domain_di_ProfileUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase(profileRepository=get(),authRepository=get()) } 
}
public val com.essntl.features.profile.domain.di.ProfileUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_profile_domain_di_ProfileUseCaseModule
